<div>
  <div class="padding_20">
    <div class="box width_100_percent">
      <div>
        <div class="flex flex-col gap-5">
          <div class="flex flex-col center gap-1">
            <lord-icon *ngIf="serviceName!='cancelTerm'" src="https://cdn.lordicon.com/drxwpfop.json" trigger="hover"
              colors="primary:#b4b4b4,secondary:#b98d78" style="width:150px;height:150px">
            </lord-icon>
            <i style="font-size: 10vh;" *ngIf="serviceName=='cancelTerm'" class="fa-solid fa-xmark"></i>
          </div>

          <div class="flex flex-col center gap-1 padding_20 text-center">
            <mat-label *ngIf="serviceName=='shiftTemplate'">{{"Are you sure do you have to delete this template?" |
              translate}}</mat-label>
          </div>


        </div>
      </div>

      <div class="flex flex-row gap-10 text-[1rem] sm:text-[1.35rem]">
        <button (click)="closePopup()" type="button"
          class="w-1/2 px-5 py-[.5rem] rounded-[.25rem] bg-[#dadada] text-[#696767] hover:bg-[#c4c4c4] shadow-md active:scale-[0.985] active:shadow-sm">
          {{"back" | translate}}
        </button>

        <button *ngIf="serviceName=='shiftTemplate'" (click)="deleteFunction()"
          class="w-1/2 px-5 py-[.5rem] rounded-[.25rem] text-white shadow-md active:scale-[0.985] active:shadow-sm bg-[#b98d78] hover:bg-[#a57d6a]">
          {{"delete" | translate}}
        </button>
      </div>
    </div>
  </div>
</div>